import React from "react";
import DraftJobs from "../components/DraftJobs/DraftJobs";

const DraftJobsPage = () => {
  return <DraftJobs />;
};

export default DraftJobsPage;
